/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_BalanceInputs */

const en_student_balance = /** @type {(inputs: Student_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balance`)
};

const he_student_balance = /** @type {(inputs: Student_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יתרה`)
};

/**
* | output |
* | --- |
* | "Balance" |
*
* @param {Student_BalanceInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_balance = /** @type {((inputs?: Student_BalanceInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_BalanceInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_balance(inputs)
	return he_student_balance(inputs)
});